import { render, staticRenderFns } from "./Background.vue?vue&type=template&id=76d15eb6&scoped=true&"
import script from "./Background.vue?vue&type=script&lang=js&"
export * from "./Background.vue?vue&type=script&lang=js&"
import style0 from "./Background.vue?vue&type=style&index=0&id=76d15eb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d15eb6",
  null
  
)

export default component.exports